import { Controller } from "@hotwired/stimulus"

// Auto-submitting CMS filter form. Attach to the `<form>` itself.
//
// - Submits the form whenever any radio/checkbox/select inside changes.
// - Provides `setStatus` action for the `<a class="Status">` buttons in
//   `cms/form/filters/_status_select`: writes the status id into the
//   hidden `[data-filters-target="statusId"]` input and submits.
//
// Usage:
//   <form data-controller="filters" data-action="change->filters#onChange" …>
//     …
//     <a data-action="click->filters#setStatus" rel="<status.id>">…</a>
//     …
//     <input type="hidden" data-filters-target="statusId" name="status_id" />
//   </form>
export default class extends Controller {
  static targets = ["statusId"]

  onChange(event) {
    const el = event.target
    if (el.tagName === "SELECT" || el.type === "radio" || el.type === "checkbox") {
      this.element.submit()
    }
  }

  setStatus(event) {
    event.preventDefault()
    event.stopPropagation()
    const value = event.currentTarget.dataset.statusValue || event.currentTarget.getAttribute("rel") || ""
    if (this.hasStatusIdTarget) this.statusIdTarget.value = value
    this.element.submit()
  }
}
